import { render, staticRenderFns } from "./sale_chart.vue?vue&type=template&id=36de9507&scoped=true"
import script from "./sale_chart.vue?vue&type=script&lang=js"
export * from "./sale_chart.vue?vue&type=script&lang=js"
import style0 from "./sale_chart.vue?vue&type=style&index=0&id=36de9507&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36de9507",
  null
  
)

export default component.exports